export const initialState = () => ({
  bank: "",
  bankName: "",
  agency: "",
  account: "",
  whatsapp: "",
  clientType: {},
  contractType: null,
  contractModel: {},
  uuid: "",
  billingAddress: {
    isSameAddress: true,
    cep: "",
    address: "",
    neighborhood: "",
    city: "",
    cityId: "",
    latitude: "",
    longitude: "",
    state: "",
    stateId: "",
    number: "",
    noNumber: false
  },
  complements: [],
  providerAddressUuid: ""
})
